var _path, _path2, _path3, _path4, _path5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCameraCardIcon10(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.1543 5.50474V14.4901C1.1543 15.1639 1.70054 15.7102 2.37437 15.7102H9.08478H14.6382H15.7952C16.469 15.7102 17.0153 15.1639 17.0153 14.4901V9.99742V7.27766C17.0153 6.60384 16.469 6.05759 15.7952 6.05759H9.08478H6.95554C6.46596 6.05759 6.06908 5.66071 6.06908 5.17113C6.06908 4.68155 5.67219 4.28467 5.18261 4.28467H2.37437C1.70054 4.28467 1.1543 4.83091 1.1543 5.50474Z",
    fill: "url(#paint0_linear_1389_9586)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.13 10.2836C12.986 9.36155 12.5606 8.60054 11.8542 8.00243C11.1116 7.36119 10.2069 7.04028 9.13998 7.04028C8.0728 7.04028 7.16809 7.35753 6.42587 7.99135C5.71918 8.5974 5.29754 9.36155 5.16073 10.2836C5.13174 10.4352 5.11719 10.5793 5.11719 10.7166C5.11719 11.3221 5.31536 11.8517 5.71219 12.3061C6.10847 12.7602 6.66725 13.0922 7.38847 13.3006V13.4635C7.38847 13.6651 7.4568 13.8346 7.59376 13.9714C7.73056 14.1085 7.90005 14.1844 8.10194 14.1986C8.31101 14.2133 8.46578 14.1771 8.56679 14.0906C8.72526 14.2057 8.90198 14.2633 9.09677 14.2633C9.27696 14.2633 9.44294 14.2095 9.59409 14.1014C9.69516 14.1804 9.84276 14.2133 10.0376 14.1986C10.2393 14.1771 10.4089 14.0995 10.5458 13.9663C10.6827 13.8323 10.7511 13.6651 10.7511 13.4635V13.3446C11.5295 13.1425 12.1316 12.8039 12.5572 12.3275C12.968 11.8737 13.1734 11.3368 13.1734 10.7166C13.1734 10.5793 13.1589 10.4352 13.13 10.2836ZM8.21006 11.3274C7.9937 11.5764 7.73398 11.7004 7.43147 11.7004C7.12875 11.7004 6.86918 11.5764 6.65291 11.3274C6.43667 11.0787 6.32843 10.7775 6.32843 10.4242C6.32843 10.0712 6.43667 9.7701 6.65291 9.52192C6.86918 9.2733 7.12875 9.14895 7.43147 9.14895C7.73398 9.14895 7.9937 9.2733 8.21006 9.52192C8.42642 9.7701 8.53478 10.0712 8.53478 10.4242C8.53475 10.7775 8.42642 11.0786 8.21006 11.3274ZM9.15066 12.7602C8.9704 12.7602 8.83704 12.7138 8.75071 12.6214C8.70015 12.5637 8.67513 12.4928 8.67513 12.407C8.67513 12.2719 8.72728 12.1365 8.83183 12.0007C8.93628 11.8656 9.03885 11.7978 9.13998 11.7978C9.24092 11.7978 9.33614 11.8725 9.4264 12.0229C9.51649 12.1725 9.56192 12.3147 9.56192 12.4505C9.56192 12.6573 9.42466 12.7602 9.15066 12.7602ZM11.5352 11.3274C11.3224 11.5764 11.0612 11.7004 10.751 11.7004C10.4484 11.7004 10.1908 11.5764 9.97813 11.3274C9.76522 11.0787 9.65884 10.7775 9.65884 10.4242C9.65884 10.0712 9.76522 9.7701 9.97813 9.52192C10.1908 9.2733 10.4484 9.14895 10.751 9.14895C11.0612 9.14895 11.3225 9.2733 11.5352 9.52192C11.7476 9.7701 11.8542 10.0712 11.8542 10.4242C11.8542 10.7775 11.7476 11.0786 11.5352 11.3274Z",
    fill: "url(#paint1_linear_1389_9586)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3471 16.3996C15.3471 16.3996 18.0261 15.0601 18.0261 13.0508V10.7066L15.3471 9.7019L12.668 10.7066V13.0508C12.668 15.0601 15.3471 16.3996 15.3471 16.3996Z",
    fill: "#D9D9D9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3471 16.3996C15.3471 16.3996 18.0261 15.0601 18.0261 13.0508V10.7066L15.3471 9.7019L12.668 10.7066V13.0508C12.668 15.0601 15.3471 16.3996 15.3471 16.3996Z",
    fill: "url(#paint2_linear_1389_9586)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8652 12.5584L15.0472 13.7403L17.0171 11.7704",
    stroke: "white",
    strokeWidth: 0.590974,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1389_9586",
    x1: 5.13246,
    y1: 5.90615,
    x2: 18.0116,
    y2: 16.9529,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#799DFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BAFBFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1389_9586",
    x1: 9.14532,
    y1: 7.04028,
    x2: 9.14532,
    y2: 14.2633,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.37
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1389_9586",
    x1: 15.3471,
    y1: 9.7019,
    x2: 15.3471,
    y2: 16.3996,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32FF84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2DC0FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCameraCardIcon10);
export default __webpack_public_path__ + "static/media/camera_card_icon10.ff1dbc505f5ea5110401a328ac40fc93.svg";
export { ForwardRef as ReactComponent };